// dev
// export const nftAddress = '0x815F3Efa3f5eF0066EE5AaD7489588C177Be5d12'
// export const bankAddress = '0x268F17a871aB13B42f68922dC907b0C28F2A3208'
// export const fishTokenAddress = '0x8624ebd154CEcCF26EE072cE39B765f55DA0aE89'

// prod
export const nftAddress = '0x631b0F9B4D1b159ea29a22cCba5F4CCC52E17923'
export const bankAddress = '0x7D09A4af8b06a3f0381041c7A8f510F84077502C'
export const fishTokenAddress = '0x8B7d3fC1a8892C187F1f517837865C95B62d00Ed'
